import React from 'react';
import '../CSS/Global.css';
import MainSection from './MainSection';
import Carousel from './PosterCarousel';
import Philosophy from './Philosophy';
import Projects from './HomeProjects';

const Home = () => {
  return (
    <>
      <MainSection />
      <Carousel />
      <Philosophy />
      <Projects />
    </>
  );
};

export default Home;
